import calc from 'calculatorjs'
import { isEmbargoGoods } from '@g/utils/tbdgUtils'

const state = {
  prepareModel: null,
  nearAddrid: '',
  form: {
    receiveAddrid: '',
    othderAddrid: '',
  },
  goodsInfo: null,
  buyNumMap: {},
  previewData: null,
  firstPropsValue: '',
  freight: 0, // 预估运费

  stepId1688: '',
  orderConfirmHtml: '',

  detailOrder: null,

  choseDgids: [],
  couponrelList: [],
  invoiceInfo: null,

  flow: 'general', // general: 批發(現貨), fenxiao: 代發(分銷)

  skuChose: [], // 选择的 SKU，有几级规格就有几个值
}

const converGoodsInfo = (goodsInfo) => {
  if (!Array.isArray(goodsInfo.tagInfoList)) {
    goodsInfo.tagInfoList = []
  }
  goodsInfo.isOnePsale = goodsInfo.tagInfoList.find(v => v.key === 'isOnePsale')?.value

  if (!Array.isArray(goodsInfo.productSkuInfos)) {
    // https://detail.1688.com/offer/676740810309.html
    // 没有 SKU 的商品   660055603761 840253212
    goodsInfo.productSkuInfos = [{
      ...goodsInfo.productSaleInfo,
      priceRangeList: undefined,
      skuId: '',
      specId: '',
      skuAttributes: [
        {
          attributeId: 1234,
          attributeName: '采购量',
          attributeNameTrans: '',
          value: '',
          valueTrans: '',
          skuImageUrl: ''
        }
      ],
    }]
  }
  goodsInfo.hasPromoPrice = false
  goodsInfo.rawMinOrderQuantity = goodsInfo.minOrderQuantity
  if (!goodsInfo.tagInfoList.find(v => v.key === 'isSupportMix')?.value) {
    // 不支持混批
    goodsInfo.sellerMixSetting = undefined
  }

  if (goodsInfo.sellerMixSetting?.mixNumber && goodsInfo.productSaleInfo.priceRangeList) {
    goodsInfo.minOrderQuantity = Math.min(goodsInfo.minOrderQuantity, goodsInfo.sellerMixSetting.mixNumber)
    if (goodsInfo.productSaleInfo.priceRangeList[0].startQuantity > goodsInfo.sellerMixSetting.mixNumber) {
      goodsInfo.productSaleInfo.priceRangeList.splice(0, 1, {
        ...goodsInfo.productSaleInfo.priceRangeList[0],
        startQuantity: goodsInfo.sellerMixSetting.mixNumber,
      })
    }
  }
  return goodsInfo
}
// https://open.1688.com/solution/solutionDetail.htm?solutionKey=1697014160788#apiAndMessageList
const getters = {
  erExchRateDisplay (state) { // 显示的汇率，不含1%的手续费
    if (state.prepareModel && state.prepareModel.exchrate) {
      return Number((state.prepareModel.exchrate.erExchRate * 0.99).toFixed(3))
    }
    return 0
  },
  skuProps (state) {
    const skuProps = []
    if (state.goodsInfo && state.goodsInfo.sku_list) {
      state.goodsInfo.sku_list.forEach((skuItem) => {
        skuItem.properties?.forEach((prop) => {
          let skuProp = skuProps.find((item) => item.prop_name === prop.prop_name)
          if (!skuProp) {
            skuProp = {
              prop_name: prop.prop_name,
              prop_id: prop.prop_id,
              attrs: [],
            }
            skuProps.push(skuProp)
          }
          if (!skuProp.attrs.find((item) => item.value_id === prop.value_id)) {
            skuProp.attrs.push({
              value_id: prop.value_id,
              value_name: prop.value_name,
              pic_url: skuItem.pic_url,
            })
          }
        })
      })
    }
    return skuProps
  },
  currSkuInfo (state, getters) {
    if (getters.skuProps.length > 0 && getters.skuProps.length !== state.skuChose.filter(item => item).length) {
      return null
    }
    if (state.goodsInfo.sku_list.length === 1) {
      return state.goodsInfo.sku_list[0]
    }
    const skuItem = state.goodsInfo.sku_list.find((skuItem) => {
      return skuItem.properties?.every((prop, propsIndex) => state.skuChose[propsIndex] === prop.value_id)
    })
    return skuItem
  },
  currSkuPrice (state, getters) {
    // 巧巧朗价格
    if (getters.currSkuInfo) {
      return (getters.currSkuInfo.qqlPrice || getters.currSkuInfo.promotion_price || getters.currSkuInfo.price) / 100
    }
    return (state.goodsInfo.qqlPrice || state.goodsInfo.promotion_price || state.goodsInfo.price) / 100
  },
  currSkuPriceOrigin (state, getters) {
    // 原价
    if (getters.currSkuInfo) {
      return (getters.currSkuInfo.promotion_price || getters.currSkuInfo.price) / 100
    }
    return (state.goodsInfo.promotion_price || state.goodsInfo.price) / 100
  },
  currSkuImg (state, getters) {
    if (getters.currSkuInfo?.pic_url) {
      return getters.currSkuInfo.pic_url
    }
    if (state.goodsInfo.pic_urls?.[0]) {
      return state.goodsInfo.pic_urls?.[0]
    }
    if (state.goodsInfo.sku_list?.[0]?.pic_url) {
      return state.goodsInfo.sku_list?.[0]?.pic_url
    }
    return 'https://static.kkren.com.tw/static/images/tbdg/def-img.jpeg'
  },
  buyText (state) {
    return Object.keys(state.buyNumMap).map(key => {
      if (state.goodsInfo && state.goodsInfo.productSkuInfos && state.buyNumMap[key] > 0) {
        const skuInfo = state.goodsInfo.productSkuInfos.find(v => String(v.specId) === key)
        return `${skuInfo.skuAttributes.map(attr => attr.value).join(' ')} x${state.buyNumMap[key]}`
      }
      return ''
    }).filter(s => s).join('\n')
  },
  buyNumMapStats (state) {
    return {
      amount: 0,
      qtyTotal: 0,
      goodsTypeQty: 0,
    }
  },
  minOrderQuantity (state) {
    return state.flow === 'fenxiao' ? 1 : state.goodsInfo.minOrderQuantity
  },
  batchNumber (state) {
    // 手數
    return state.flow === 'fenxiao' ? 1 : state.goodsInfo.batchNumber
  },
  catEmbargoInfo (state) {
    return isEmbargoGoods(state.goodsInfo.tpCatalog)
  },
  kkrenFreeShipping (state) {
    return state.goodsInfo.sku_list.some(sku => sku.kkrenFreeShipping)
  },
}

const mutations = {
  setNearAddrid (state, nearAddrid) {
    state.nearAddrid = nearAddrid
  },
  setDetailOrder (state, detailOrder) {
    state.detailOrder = detailOrder
  },
  setPrepareModel (state, prepareModel) {
    state.prepareModel = prepareModel
  },
  setCouponrelList (state, couponrelList) {
    state.couponrelList = couponrelList
  },
  setFreight (state, freight) {
    state.freight = freight
  },
  setGoodsInfo (state, goodsInfo) {
    state.goodsInfo = goodsInfo ? converGoodsInfo(goodsInfo) : goodsInfo
  },
  setForm (state, form) {
    state.form = form
  },
  setBuyNumMap (state, buyNumMap) {
    state.buyNumMap = buyNumMap
  },
  setPreviewData (state, previewData) {
    state.previewData = previewData
  },
  setFirstPropsValue (state, firstPropsValue) {
    state.firstPropsValue = firstPropsValue
  },
  setStepId1688 (state, stepId1688) {
    state.stepId1688 = stepId1688
  },
  setOrderConfirmHtml (state, orderConfirmHtml) {
    state.orderConfirmHtml = orderConfirmHtml
  },
  initForm (state, form, rootState) {
    state.form = {
      dgType: 'DP', // DP: 直接付款, PA: 改價   NS:不指定賣家
      dgPymtMethod: 'BC',
      dgSource: '',
      bcid: '',
      orderRemark: '',
      orderRemarkLanguage: 'zh',
      receiveAddrid: '',
      othderAddrid: '',
      addressParam: undefined,
      goods: {
        // 545557499253
        // 607537095667
        // 793014177217 多级规格
        // gsUrl: 'https://detail.tmall.com/item.htm?id=793014177217&',
        gsUrl: '',
        gsTitle: '',
      },
      quantity: 1,
      agreeService: localStorage.getItem('tbdgAgreeService') === '1',
    }
    state.goodsInfo = null
    state.prepareModel = null
    state.previewData = null
    state.freight = 0
    state.buyNumMap = {}
  },

  setChoseDgids (state, choseDgids) {
    state.choseDgids = choseDgids
  },
  setFlow (state, flow) {
    state.flow = flow
  },
  setInvoiceInfo (state, invoiceInfo) {
    state.invoiceInfo = invoiceInfo
  },
  setSkuChose (state, skuChose) {
    state.skuChose = skuChose
  },
}

const actions = {
  prepare ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/tb-dgorder/prepare', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  createPreview ({ state, commit, rootState }, { cargoParamList, cartOrder = true, ...params }) {
    if (!cargoParamList) {
      cargoParamList = Object.keys(state.buyNumMap).map(specId => {
        return {
          specId,
          quantity: state.buyNumMap[specId],
          offerId: state.goodsInfo.itemid
        }
      }).filter(item => item.quantity > 0)
    }

    return rootState.axios.post('/magicbuy/ali-dg/trade/order/create-preview', {
      ...params,
      cargoParamList,
      cartOrder,
      options: undefined,
    }, {
      baseURL: 'https://apisp.jyb.com.tw',
    }).then(res => {
      commit('setPreviewData', res.data.model)
      return res
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
